import Image from "next/image";
import { buildImageSrc } from "~lib/storyblok";
import { cn } from "~utils";
import type { TileItemProps } from "../types";

type TileSectionImageProps = {
  mainBlok: TileItemProps["mainBlok"];
  blok: TileItemProps["blok"];
} & Partial<Omit<TileItemProps, "mainBlok" | "blok">>;

const IMAGE_WIDE_WIDTH = 560;
const IMAGE_DEFAULT_WIDTH = 460;
const IMAGE_HEIGHT = 240;
const IMAGE_SQUARE_SIZE = 500;

function TileSectionImage({ blok, mainBlok }: TileSectionImageProps) {
  const isWide = mainBlok.variant === "wide";
  const squareImages = mainBlok.squareImages ?? false;

  // ASPECT RATION
  const wideAspectRatio = isWide
    ? IMAGE_WIDE_WIDTH / IMAGE_HEIGHT
    : IMAGE_DEFAULT_WIDTH / IMAGE_HEIGHT;
  const aspectRatioSquare = undefined;
  const aspectRatio = squareImages ? aspectRatioSquare : wideAspectRatio;

  // SIZE
  const squreSize = IMAGE_SQUARE_SIZE;
  const wideWidth = isWide ? IMAGE_WIDE_WIDTH : IMAGE_DEFAULT_WIDTH;
  const wideHeight = IMAGE_HEIGHT;

  const width = squareImages ? squreSize : wideWidth;
  const height = squareImages ? squreSize : wideHeight;

  const imageBorderRadius = mainBlok.itemBorderRadius ?? "rounded-md";

  return blok.image?.filename ? (
    <div
      className={cn(
        squareImages && "relative aspect-square overflow-hidden",
        imageBorderRadius,
      )}
    >
      <Image
        className={cn(
          "w-full",
          squareImages && "h-full origin-top scale-y-[1.02] object-cover",
        )}
        alt={blok.image.alt ?? ""}
        src={buildImageSrc(blok.image.filename, {
          aspectRatio: aspectRatio,
          focus: blok.image.focus,
        })}
        width={width}
        height={height}
        sizes="(max-width: 768px) 90vw, (max-width: 1048px) 80vw, 40vw"
      />
    </div>
  ) : null;
}

export { TileSectionImage };
